import TheGrid from '@/views/users/grid'
import Edit from '@/views/users/edit'

export default {
  path: '/users',
  redirect: '/users/index',
  name: 'users',
  meta: {
    auth: {
      redirect: {
        name: 'users.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Utilizadores'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'users.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'users.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'users.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
